import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconTranslateAltStyle0 = cosmosIconCss;

const CosmosIconTranslateAlt$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTranslateAlt extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '829bcf5f8f5c80def114a3cf7618b105f9c8815a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2a4a7d8a324b9d42761e4911635db0ea7885cb05', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e18a74c66e8c9285ad81c4bf1ad0763a9dfb4c1b', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H10v7.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H12V2.5a.5.5 0 0 0-.5-.5h-9Zm4 1.5h1V5H10v1H8.972c-.016.115-.04.246-.074.389a4.646 4.646 0 0 1-1.114 2.044 8.68 8.68 0 0 0 1.088.592 11.69 11.69 0 0 0 1.25.49l.018.005.005.002a322.455 322.455 0 0 0-.29.957h-.002l-.006-.003-.024-.007a7.146 7.146 0 0 1-.385-.131c-.252-.092-.6-.227-.985-.405A9.142 9.142 0 0 1 7 9.11a9.142 9.142 0 0 1-1.453.824 12.713 12.713 0 0 1-1.37.536l-.024.007-.006.002h-.002S4.144 10.48 4 10s-.144-.478-.145-.478l.005-.002.017-.005a6.054 6.054 0 0 0 .345-.118c.232-.084.553-.209.906-.372a8.68 8.68 0 0 0 1.088-.592 4.646 4.646 0 0 1-1.114-2.044A3.885 3.885 0 0 1 5.028 6H4V5h2.5V3.5Zm.62 4.174a2.91 2.91 0 0 1-.12.132 3.648 3.648 0 0 1-.926-1.652A2.995 2.995 0 0 1 6.04 6h1.918c-.009.048-.02.1-.033.154-.096.398-.314.949-.805 1.52Zm6.939 4.476c.316-.885 1.567-.885 1.883 0L18 18h-1l-.725-2h-2.55L13 18h-1l2.059-5.85Zm.941.336L15.912 15h-1.824L15 12.486ZM18 5v2h-1V5h-2V4h2a1 1 0 0 1 1 1ZM4 17v-2h1v2h2v1H5a1 1 0 0 1-1-1Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconTranslateAltStyle0; }
}, [1, "cosmos-icon-translate-alt", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-translate-alt"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-translate-alt":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTranslateAlt$1);
            }
            break;
    } });
}

const CosmosIconTranslateAlt = CosmosIconTranslateAlt$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTranslateAlt, defineCustomElement };
